import { NestingParentDropdownItem } from "@app/shared/checkbox-dropdown/types";

/* NestingParentDropdownItem includes DropdownItem<string>,
 * so TS believes that every county key is a string. They might be a number, depending on the API response. */
export const calculateServiceAreaSelections =
  (serviceAreaOptions: NestingParentDropdownItem[], filterServiceArea: string[], alwaysPushCounties: boolean = false): { counties: string[], states: string[] } => {
        const states: string[] = [];
        const counties: string[] = [];
        serviceAreaOptions.forEach((state) => {
            const selectedCounties: string[] = [];
            state.children.forEach((county) => {
                if (filterServiceArea.includes(county.key)) {
                    selectedCounties.push(county.key);
                }
            })
            if (selectedCounties.length === state.children.length) {
              states.push(state.key);

              if (alwaysPushCounties) {
                counties.push(...selectedCounties);
              }
            } else {
                counties.push(...selectedCounties);
            }
        });

        return { counties, states };
    }
